import {
  Box,
  Fade,
  Modal,
  Grid,
  Button,
  useMediaQuery,
  Divider,
  Checkbox,
  styled,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Close } from "@mui/icons-material";
import CInput from "../CInput";
import theme from "../../config/theme";
import { newFormattedAmount } from "../../utils/CommonFunction";
import moment from "moment";
import _, { isEmpty } from "lodash";
import { getNewApiData } from "../../utils/APIHelper";
import { Setting } from "../../utils/Setting";
import { toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import styles from "./styles";
import { ReactComponent as NewDesignIcon } from "../../assets/svg/NewDesignIcon.svg";
import { ReactComponent as NewRenovationIcon } from "../../assets/svg/NewRenovationIcon.svg";
import CDueDatePicker from "../CDueDatePicker";

const errorObj = {
  groupNameError: false,
  groupNameMsg: "",
  dueDateError: false,
  dueDateMsg: "",
};

const StyledButton = styled(Button)(({ theme }) => ({
  background: "#4D6BF6",
  color: "#ffffff",
  boxShadow: "none",
  border: "1px solid #4D6BF6",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

const GreyStyledButton = styled(Button)(({ theme }) => ({
  background: "#fff",
  color: "#0D0D0E",
  boxShadow: "none",
  border: "1px solid #D7D8D9",
  whiteSpace: "nowrap",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "10px",
  padding: ".5vh 1vw",
  letterSpacing: "0",
}));

function PaymentGroupModal({
  isCreationOpen,
  visible,
  handleCloseCreation,
  selectedPaymentGroup,
  isEdit,
  milestones,
  paymentGroups,
  proposalId,
  getProjectDetails,
  setOuterButtonLoader,
}) {
  const sm = useMediaQuery(theme.breakpoints.down("sm"));
  const md = useMediaQuery(theme.breakpoints.down("md"));

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: sm ? 300 : 750,
    bgcolor: "background.paper",
    borderRadius: 1,
    boxShadow: 24,
    p: "2vh 2vw",
    fontFamily: "Inter Tight",
  };
  const [errObj, setErrObj] = useState(errorObj);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [paymentGroupDetails, setPaymentGroupDetails] = useState({
    groupName: "",
    due_date: null,
  });
  const [endDate, setEndDate] = useState(null);
  const [selectedMilestones, setSelectedMilestones] = useState([]);

  const assignedMilestoneIds = paymentGroups.flatMap((pg) =>
    pg.milestones.map((m) => m.id)
  );

  const assignedMilestones = isEdit
    ? selectedPaymentGroup?.milestones || []
    : [];

  const unassignedMilestones = milestones.filter(
    (milestone) => !assignedMilestoneIds.includes(milestone.id)
  );

  const allMilestones = [...assignedMilestones, ...unassignedMilestones];

  useEffect(() => {
    if (isEdit && selectedPaymentGroup) {
      setSelectedMilestones(selectedPaymentGroup.milestones.map((m) => m.id));
    }
  }, [isEdit, selectedPaymentGroup]);

  const handleMilestoneSelection = (id) => {
    setSelectedMilestones((prevSelected) => {
      const newSelected = prevSelected.includes(id)
        ? prevSelected.filter((mId) => mId !== id) // Unselect
        : [...prevSelected, id]; // Select

      // Get selected milestone objects
      const selectedMilestones = milestones.filter((m) =>
        newSelected.includes(m.id)
      );

      if (selectedMilestones.length > 0) {
        // Get the latest end_date
        const maxEndDate = selectedMilestones
          .map((m) => m.end_date)
          .reduce(
            (max, date) => (new Date(date) > new Date(max) ? date : max),
            selectedMilestones[0]?.end_date
          );

        setEndDate(maxEndDate);
      } else {
        // If no milestones are selected, fallback to original due date
        setEndDate(
          isEdit && selectedPaymentGroup ? selectedPaymentGroup.due_date : null
        );
      }

      return newSelected;
    });
  };

  useEffect(() => {
    if (isEdit && selectedPaymentGroup) {
      setEndDate(selectedPaymentGroup.due_date);
    } else {
      setEndDate(null);
    }
  }, [isEdit, selectedPaymentGroup]);

  const submitPaymentGroup = async (data, isEditFlag) => {
    console.log("Data", data);
    setButtonLoader(true);
    setOuterButtonLoader(true);
    try {
      const method = isEditFlag ? "PUT" : "POST";
      const response = await getNewApiData(
        `${Setting.endpoints.newPaymentGroup}`,
        method,
        data,
        { "Content-Type": "application/json" },
        true
      );
      if (response) {
        toast.success(
          isEditFlag
            ? "Payment Group Updated Successfully"
            : "Payment Group Added Successfully"
        );
        getProjectDetails(proposalId);
      }
    } catch (error) {
      toast.error(error.toString());
    } finally {
      setButtonLoader(false);
      setOuterButtonLoader(false);
    }
  };

  const validate = () => {
    const error = { ...errObj };
    let valid = true;

    // Validate group name
    if (isEmpty(paymentGroupDetails?.groupName)) {
      valid = false;
      error.groupNameError = true;
      error.groupNameMsg = "Please enter the name";
    }

    // Validate selected milestones
    if (!selectedMilestones || selectedMilestones.length === 0) {
      toast.error("Please select at least one milestone to proceed");
      return; // Stop function execution
    }

    setErrObj(error);

    if (valid) {
      handleCloseCreation();

      const formattedEndDate = moment(endDate).format("YYYY-MM-DD");

      let body = {
        paymentGroup: {
          groupId: isEdit ? selectedPaymentGroup?.group_id : uuidv4(),
          groupName: paymentGroupDetails?.groupName,
          refId: parseInt(proposalId),
          dueDate: formattedEndDate,
          ...(isEdit
            ? {} // Editing: Remove extra fields
            : { refType: "proposal", type: "PAYMENT_GROUP" }), // Creation: Include extra fields
        },
        milestones:
          selectedMilestones?.map((id) => ({
            milestoneId: id,
          })) || [],
      };

      console.log("body", body);
      submitPaymentGroup(body, isEdit);
    }
  };

  useEffect(() => {
    console.log("miles", milestones, paymentGroups);
    if (selectedPaymentGroup) {
      console.log("selectedM", selectedPaymentGroup);
      setPaymentGroupDetails({
        groupName: selectedPaymentGroup?.group_name || "",
        due_date: selectedPaymentGroup?.due_date || "",
      });
    }
  }, [selectedPaymentGroup]);

  return (
    <>
      <Modal open={isCreationOpen || visible} onClose={handleCloseCreation}>
        <Fade in={isCreationOpen || visible}>
          <Box sx={style}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="addMilestoneHeader">
                {isEdit ? "Update" : "Add"} Payment Group
              </div>
              <Close
                style={{ cursor: "pointer" }}
                onClick={() => handleCloseCreation()}
              />
            </div>
            <Grid container>
              <Grid
                item
                container
                columnGap={2}
                wrap={md ? "wrap" : "nowrap"}
                mt={2}
              >
                <Grid item xs={12} md={6} mb={2}>
                  <CInput
                    label={<span>Name</span>}
                    placeholder="Enter name..."
                    value={paymentGroupDetails.groupName}
                    onChange={(e) => {
                      setPaymentGroupDetails({
                        ...paymentGroupDetails,
                        groupName: e.target.value,
                      });
                      setErrObj({
                        ...errObj,
                        groupNameError: false,
                        groupNameMsg: "",
                      });
                    }}
                    inputProps={{ maxLength: 50 }}
                    error={errObj.groupNameError}
                    helpertext={errObj.groupNameMsg}
                  />
                </Grid>
                <Grid item xs={12} md={6} mb={2}>
                  <CDueDatePicker
                    value={endDate}
                    error={errObj?.dueDateError}
                    helperText={errObj?.dueDateMsg}
                  />
                </Grid>
              </Grid>
            </Grid>

            {allMilestones?.length > 0 && (
              <>
                <div
                  style={{
                    ...styles.columnFlex,
                    gap: "10px",
                    maxHeight: "40vh",
                    overflowY: "scroll",
                    scrollbarWidth: "none",
                  }}
                >
                  {allMilestones?.map((milestone) => (
                    <div style={styles.budgetRow} key={milestone.id}>
                      <div style={{ ...styles.rowFlex, flex: 2 }}>
                        <Box display="flex" alignItems="center" gap="10px">
                          <Checkbox
                            checked={selectedMilestones.includes(milestone.id)}
                            onChange={() =>
                              handleMilestoneSelection(milestone.id)
                            }
                          />
                          <span
                            style={{
                              ...styles.small_sub_heading,
                              ...styles.rowFlex,
                              gap: "5px",
                            }}
                          >
                            {milestone?.tags === "Design" ? (
                              <NewDesignIcon />
                            ) : (
                              <NewRenovationIcon />
                            )}
                            {milestone?.milestone_name}
                          </span>
                        </Box>
                      </div>

                      <div
                        style={{ ...styles.columnFlex, flex: 1, gap: "7px" }}
                      >
                        <h3 style={styles.small_text}>End Date</h3>
                        <div style={styles.small_sub_heading}>
                          {milestone?.end_date
                            ? moment(milestone?.end_date).format("MMM DD, YYYY")
                            : "-"}
                        </div>
                      </div>

                      <div
                        style={{ ...styles.columnFlex, flex: 1, gap: "7px" }}
                      >
                        <h3 style={styles.small_text}>Amount</h3>
                        <div style={styles.small_sub_heading}>
                          {newFormattedAmount(milestone?.amount)}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            )}

            <Divider style={{ marginTop: "2vh" }} />
            <Grid
              item
              container
              justifyContent="center"
              gap={sm ? 1 : 2}
              wrap="nowrap"
              marginTop="10px"
            >
              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-start" }}
              >
                <GreyStyledButton onClick={handleCloseCreation}>
                  Cancel
                </GreyStyledButton>
              </Grid>

              <Grid
                item
                xs={6}
                sx={{ display: "flex", justifyContent: "flex-end" }}
              >
                <StyledButton
                  variant="contained"
                  onClick={validate}
                  disabled={buttonLoader}
                >
                  {isEdit ? "Update" : "Add"} Payment Group
                </StyledButton>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default PaymentGroupModal;
